<template>
  <div>
    <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
    <div class="section" v-if="this.openMarketInfo.mblSvcDivsCd != 'LZP0002200'">
    <!--[ST] RITM2876892 M2M 요금약정기간 추가 건 --> 
      <div class="section-header">
        <h3>가입계약서 교부방법</h3>
      </div>
      <div class="section-body">
        <dl class="field-group">
          <dt class="field-label">
            신청서 교부방법
          </dt>
          <dd class="field-control">
            <ul class="notice-text-list">
              <li class="notice-text">
                가입계약서는 개통일 기준 30 일 이내 선택한 교부 방법으로
                발송되며, 교부 방법을 선택하지 않을 경우 MMS 로 발송됩니다.
              </li>
            </ul>

            <div class="field-control-sub">
              <div
                id="radio-button-container-issue-way-mms"
                class="input-container input-horizontal"
              >
                <input
                  id="issue-way-mms"
                  ref="ref_entrAppfDvrMthdCd"
                  v-model="registration.entrAppfDvrMthdCd"
                  @change="setAppfDvrMthd('SMS')"
                  type="radio"
                  name="issue-way"
                  value="SMS"
                  class="input-radio"
                  title="신청서 교부방법선택"
                />
                <label for="issue-way-mms" class="input-label">SMS</label>
              </div>
              <div
                id="radio-button-container-issue-way-email"
                class="input-container input-horizontal"
              >
                <input
                  id="issue-way-email"
                  v-model="registration.entrAppfDvrMthdCd"
                  @change="setAppfDvrMthd('EMAIL')"
                  type="radio"
                  name="issue-way"
                  value="EMAIL"
                  class="input-radio"
                  title="신청서 교부방법선택"
                />
                <label for="issue-way-email" class="input-label">E-MAIL</label>
              </div>
              <div
                id="radio-button-container-issue-way-fax"
                class="input-container input-horizontal"
              >
                <input
                  id="issue-way-fax"
                  v-model="registration.entrAppfDvrMthdCd"
                  @change="setAppfDvrMthd('FAX')"
                  type="radio"
                  name="issue-way"
                  value="FAX"
                  class="input-radio"
                  title="신청서 교부방법선택"
                />
                <label for="issue-way-fax" class="input-label">FAX</label>
              </div>
            </div>

            <ul
              class="notice-text-list"
              v-if="registration.entrAppfDvrMthdCd === 'SMS'"
            >
              <li class="notice-text">
                SMS는 가입 하신 휴대폰 번호로 발송됩니다
              </li>
            </ul>

            <div v-show="registration.entrAppfDvrMthdCd === 'EMAIL'">
              <div class="field-control-sub">
                <div class="input-container">
                  <input
                    id="same-issueway-email-with-customer"
                    v-model="sameWithCustomerEmailAddr"
                    type="checkbox"
                    name="agreeContract"
                    class="input-checkbox input-text"
                  />
                  <label
                    @click="copyCustomerEmailAddr"
                    for="same-issueway-email-with-customer"
                    class="input-label"
                    >위 가입자 정보와 동일</label
                  >
                </div>
              </div>
              <div class="field-control-sub">
                <div class="m-input-half">
                  <input
                    v-model="emailId"
                    ref="ref_emailId"
                    :readonly="emailDisabled"
                    type="text"
                    @input="onlyText"
                    name="emailId"
                    class="input-text input-width-xsmall input-font"
                    autocomplete="off"
                    title="이메일 아이디 입력"
                    placeholder="email ID 입력"
                  />
                  <span class="field-group-space">@</span>
                  <select
                    ref="ref_emailDomain"
                    v-model="selectedEmailDomain"
                    :readonly="emailDisabled"
                    name="emailDomain"
                    class="input-width-xsmall"
                    title="이메일 도메인 선택"
                    @change="changeEmailDomain()"
                  >
                    <option value="">직접입력</option>
                    <option
                      v-for="emailDomain in emailDomainList"
                      v-bind:key="emailDomain.cmmCdv"
                      :value="emailDomain.cmmCdv"
                    >
                      {{ emailDomain.cmmCdvNm }}
                    </option>
                  </select>
                </div>
                <div class="m-input-half">
                  <input
                    v-model="emailDomain"
                    type="text"
                    @input="onlyText"
                    name="emailDomain"
                    :readonly="emailDisabled"
                    class="input-text input-width-small input-font"
                    autocomplete="off"
                    title="이메일 도메인 직접입력"
                  />
                  <button type="submit" @click="submitEmail">확인</button>
                </div>
              </div>
            </div>

            <div
              v-show="registration.entrAppfDvrMthdCd === 'FAX'"
              class="field-control-sub"
            >
              <input
                ref="ref_entrAppfDvrMthdNm"
                v-model="registration.entrAppfDvrMthdNm"
                type="text"
                @input="onlyNumber"
                name="faxNo"
                autocomplete="off"
                maxlength="11"
                title="팩스번호 입력"
                placeholder="'-' 없이 입력하세요"
                class="input-text input-width-small input-font "
              />
            </div>
          </dd>
        </dl>
      </div>
    </div>

    <div class="section">
      <div class="section-header">
        <h3>최종확인</h3>
      </div>
      <div class="section-body section-signature">
        <dl class="field-group">
          <dt class="blind">신청내용 확인 동의</dt>

          <dd id="checkbox-container-iphone-agreement" class="field-control">
            <div class="field-control-sub input-wrap">
              <div class="input-container mw100 pc-float-left">
                <p>가입 신청 내역에 이상 없음을 확인하였습니다.</p>
              </div>
              <div class="input-container pc-float-right">
                <input
                  id="registration-agreement"
                  ref="ref_issueWayChk"
                  @click="clickIssueWayChk"
                  v-model="issueWayChk"
                  type="checkbox"
                  name="issue-way-agreement"
                  class="input-checkbox input-text"
                />
                <label for="registration-agreement" class="input-label"
                  >확인</label
                >
              </div>
            </div>
          </dd>
        </dl>
      </div>
    </div>
    <v-dialog />
  </div>
</template>

<script>
import {
  commCode,
  getBlEmailBlock
} from '@/api/common'

export default {
  name: 'IssueWaySection',

  //[ST] RITM2876892 M2M 요금약정기간 추가 건
  props: {
    registrationProps: Object,
    openMarketInfoProps: Object
  },
  //[ED] RITM2876892 M2M 요금약정기간 추가 건

  data() {
    return {
      registration: {},
      issueWay: 'NA',
      sameWithCustomerEmailAddr: false,
      emailId: '',
      emailDomain: '',
      faxNo: '',
      selectedEmailDomain: '',
      emailDisabled: false,
      emailValidation: false,
      issueWayChk: false,
      emailDomainList: [],
      //[ST] RITM2876892 M2M 요금약정기간 추가 건
      openMarketInfo: {}
      //[ED] RITM2876892 M2M 요금약정기간 추가 건
    }
  },
  computed: {},

  created() {
    // 이메일 도메인 리스트
    commCode('G162').then(res => {
      this.emailDomainList = res.data
    })
    this.selectedEmailDomain = ""
    this.sameWithCustomerEmailAddr = false
    this.registration = this.registrationProps
    this.defaultSetting()
    this.issueWayChk = false
    //[ST] RITM2876892 M2M 요금약정기간 추가 건
    this.openMarketInfo = this.openMarketInfoProps
    //[ED] RITM2876892 M2M 요금약정기간 추가 건
  },

  mounted() {
  },

  components: {},

  methods: {
    /** 
     * Function    : onlyNumber
     * Description : input값 숫자 체크
     **/
    onlyNumber(e) {
      if(e.target.name === "faxNo") this.registration.entrAppfDvrMthdNm = e.target.value.replace(/[^0-9]/gi, '')
    },

    /** 
     * Function    : onlyText
     * Description : input값 텍스트 체크
     **/
    onlyText(e) {
      if(e.target.name === 'emailId') this.emailId = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
      if(e.target.name === 'emailDomain') {
        if(this.selectedEmailDomain !== "") {
          this.selectedEmailDomain = ""
        }
        this.emailDomain = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
      }
    },

    /** 
     * Function    : validCondition
     * Description : 교부방법 필수값 validation
     **/
    validCondition() {
      let regExp
      let title = '온라인 가입신청 안내'
      
      //[ST] RITM2876892 M2M 요금약정기간 추가 건
      if( this.openMarketInfo.mblSvcDivsCd != 'LZP0002200'){
      
        if (!this.registration.entrAppfDvrMthdCd) {
          this.openAlert(
            title,
            '교부방법을 선택하세요.',
            this.$refs.ref_entrAppfDvrMthdCd
          )
          return false
        }
        if (this.registration.entrAppfDvrMthdCd === 'EMAIL') {
          if (!this.emailId) {
            this.openAlert(
              title,
              '이메일 아이디를 입력하세요.',
              this.$refs.ref_emailId
            )
            return false
          }
          if (!this.emailDomain) {
            this.openAlert(
              title,
              '이메일 도메인을 입력하세요',
              this.$refs.ref_emailDomain
            )
            return false
          }
        }
        if (this.registration.entrAppfDvrMthdCd === 'FAX') {
          if (!this.registration.entrAppfDvrMthdNm) {
            this.openAlert(
              title,
              '팩스번호를 입력하세요.',
              this.$refs.ref_entrAppfDvrMthdNm
            )
            return false
          }
        }
      }
      //[ED] RITM2876892 M2M 요금약정기간 추가 건

      if (!this.issueWayChk) {
        this.openAlert(
          title,
          '최종확인 동의여부를 확인하세요.',
          this.$refs.ref_issueWayChk
        )
        return false
      }
      return true
    },

    /** 
     * Function    : defaultSetting
     * Description : dafualt값 세팅
     **/
    defaultSetting() {
      this.setAppfDvrMthd('SMS')
    },

    /** 
     * Function    : setAppfDvrMthd
     * Description : 교부방법 선택시 이벤트
     **/
    setAppfDvrMthd(code) {
      if (code === 'SMS') {
        this.registration.entrAppfDvrMthdCd = 'SMS'
        this.registration.entrAppfDvrMthdNm = this.registration.aplcTlno
      } else if (code === 'EMAIL') {
        this.registration.entrAppfDvrMthdCd = 'EMAIL'
        this.registration.entrAppfDvrMthdNm = ''
        this.emailId = ''
        this.emailDomain = ''
        this.emailDisabled = false
      } else if (code === 'FAX') {
        this.registration.entrAppfDvrMthdCd = 'FAX'
        this.registration.entrAppfDvrMthdNm = ''
      }
    },

    /** 
     * Function    : copyCustomerEmailAddr
     * Description : 가입자와 동일한 이메일 복사
     **/
    copyCustomerEmailAddr() {
      let email = this.registration.aplcEmalAddr.split('@')
      if (!this.sameWithCustomerEmailAddr) {
        this.selectedEmailDomain = email[1]
        this.emailId = email[0]
        this.emailDomain = email[1]
      } else {
        this.selectedEmailDomain = ""
        this.emailId = ""
        this.emailDomain = ""
      }
    },

    /** 
     * Function    : changeEmailDomain
     * Description : 이메일 도메인 셀렉트박스 선택 이벤트
     **/
    changeEmailDomain() {
      if (this.selectedEmailDomain !== "") {
        this.emailDomain = this.selectedEmailDomain
      } else {
        this.emailDomain = ""
      }
    },

    /** 
     * Function    : submitEmail
     * Description : 이메일 인증
     **/
    submitEmail() {
      let title = '온라인 가입신청 안내'
      let message = ''
      let billEmailAddr = this.emailId + '@' + this.emailDomain
      if (billEmailAddr.length > 50) {
        this.openAlert(
          title,
          '허용된 이메일 자릿수를 초과하였습니다.\n다른 이메일로 입력바랍니다.',
          this.$refs.ref_emailId
        )
        return
      }
      if(this.registration.entrAppfDvrMthdCd === 'EMAIL') {
        getBlEmailBlock(billEmailAddr).then(res => {
          let blackRegYn = res.data.dsRes.blackRegYn
          let blockCntYn = res.data.dsRes.blockCntYn
          let blockCntYnMsg = res.data.dsRes.blockCntYnMsg
          if (blackRegYn === 'Y') {
            message =
              '등록하신 이메일 주소는 등록이 제한된 이메일 주소 입니다.\n이메일 주소를 확인하시어 다른 이메일 주소로 등록 해주십시오.\n(이메일 주소 이용자가 발송 차단 요청, 타인 이메일 청구서 다량 수신 건으로 등록 차단 요청)'
            this.emailDisabled = false
          } else if (blockCntYn === 'Y') {
            message =blockCntYnMsg
             // '등록하신 이메일 주소는 등록제한 횟수(5건)를 초과한 \n이메일 주소입니다.\n해당 이메일 주소로는 등록이 불가하오니, 다른 이메일 주소를 확인하시어 등록해 주십시오.'
            this.emailDisabled = false
          } else {
            message = '이메일 확인 성공하였습니다!'
            this.registration.entrAppfDvrMthdNm = billEmailAddr
            this.emailDisabled = true
            this.emailValidation = true
          }
          this.openAlert(title, message)
        })
      }
    },

    /** 
     * Function    : clickIssueWayChk
     * Description : 최종확인 동의 클릭시 이벤트인 경우 이메일 확인 체크했는지 확인
     **/
    clickIssueWayChk(e) {
      if (
        this.registration.entrAppfDvrMthdCd === 'EMAIL' &&
        !this.emailValidation
      ) {
        this.openAlert(
          '온라인 가입신청 안내',
          '이메일 확인을 해주시길 바랍니다.'
        )
        e.preventDefault()
        return false
      }
    },

    /** 
     * Function    : saveIssueWaySection
     * Description : 교부방법 저장
     **/
    saveIssueWaySection() {
      return this.registration
    },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message, ref) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button',
            handler: () => {
              this.$modal.hide('dialog')
              if (ref) {
                ref.focus()
              }
            }
          }
        ]
      })
    }
  }
}
</script>

<style scoped></style>
